module.exports = __webpack_public_path__ + "img/grillentanz6.0d8f8796.jpg";